// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oZ1J","footer":"styles_footer__1rJjy"};